import { Route } from "../../RouteModel";
import { lazy } from "react";
import { cashManagementRoutes } from "./cashManagement";
import { customerAddressRoutes } from "./address";

const CustomerList = lazy(
  () => import("../../../pages/configuration/customers/List")
);

const CustomerDetails = lazy(
  () => import("../../../pages/configuration/customers/Details")
);

const CustomerEdit = lazy(
  () => import("../../../pages/configuration/customers/Edit")
);

const CheckoutBrandingDetails = lazy(
  () =>
    import("../../../pages/configuration/customers/checkout-branding/Details")
);

const CheckoutBrandingEdit = lazy(
  () => import("../../../pages/configuration/customers/checkout-branding/Edit")
);

const CustomerCreate = lazy(
  () => import("../../../pages/configuration/customers/Create")
);

export const customerRoutes: Route = {
  path: "/configuration/customers",
  i18nName: "Customers",
  component: CustomerList,
  showChildrenInSidebar: false,
  children: [
    ...customerAddressRoutes,
    ...cashManagementRoutes,
    {
      i18nName: "Create customer",
      path: "/configuration/customers/create",
      component: CustomerCreate,
    },
    {
      i18nName: "Edit customer",
      path: "/configuration/customers/:id/edit",
      component: CustomerEdit,
    },
    {
      i18nName: "Update checkout branding",
      path: "/configuration/customers/:id/checkout-branding/edit",
      component: CheckoutBrandingEdit,
    },
    {
      i18nName: "Checkout branding",
      path: "/configuration/customers/:id/checkout-branding",
      component: CheckoutBrandingDetails,
    },
    {
      i18nName: "Edit customer",
      path: "/configuration/customers/:id/edit",
      component: CustomerEdit,
    },
    {
      i18nName: "Customer",
      path: "/configuration/customers/:id",
      component: CustomerDetails,
    },
  ],
};

export default customerRoutes;
